import { Component, OnDestroy, OnInit } from '@angular/core';
import { ZoneService } from '../../services/zone.service';
import { Zone } from '../../models/zone';
import { Sensor, SensorTypes } from '../../models/sensor';
import { Router } from '@angular/router';
import { DataService } from '../../services/data.service'
import { SocketIoService } from 'src/app/services/socket-io.service';
import { Subscription } from 'rxjs';
import { ApiService } from "src/app/services/api.service";


@Component({
    selector: 'app-gateways',
    templateUrl: './gateways.component.html',
    styleUrls: ['./gateways.component.less']
})
export class GatewaysComponent implements OnInit, OnDestroy {

    gateways: any | null = null;
    private subscription: Subscription;
    currentCompany: any = null
    currentCompanyId: string | null = null

    constructor(private zoneService: ZoneService,
        private router: Router,
        private dataService: DataService,
        private socketService: SocketIoService,
        private _api: ApiService) {
        localStorage.setItem('currentCompany', JSON.stringify(null));
        this.dataService.updateCompany(null)
        this.dataService.updateCompanyId(null)

    }

    ngOnInit(): void {
        this.getGateways();
    }

    ngOnDestroy() {
        // this.subscription.unsubscribe();
    }


    getGateways(){
        this._api.get<any>(`/gateway`).subscribe(resp => {
            this.gateways = resp.gateways;
        }, err => {
            alert(err.message);
        });
      }

   


}
